import { REACT_APP_STREAMING_URL } from '../config';

  


export const videUrlFromUaviIDAndCtx = (uavId: string) => {
  let VidU = '';
  if (uavId != '') {
    const json: string | null = localStorage.getItem('contextData') == null ?
      `{label: ${localStorage.getItem('context')}}` : localStorage.getItem('contextData');
    const data: string = json == null ? `{label: ${localStorage.getItem('context')}}` : json;
    const label = JSON.parse(data)?.label;
    //VidU = `${REACT_APP_STREAMING_URL}/${label}_${uavId}/index.m3u8`;
    VidU = `${REACT_APP_STREAMING_URL}/${label}_${uavId}`;
  }
  return VidU;
};




export const reservedPortFromCTX = () =>{
  const context: any = localStorage.getItem('contextData');
  return JSON.parse(context).reservedPort;
};
